// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5910) return "static/chunks/5910-c92d71f8195c5693.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "2f12ef13c1928910" + ".js";
};